import { type ObjectValuesUnionType } from '../utils/typing';

// Licences
export const Licences = Object.freeze({
  PT: 'PT',
  IT: 'IT',
  ES: 'ES',
  FR: 'FR',
  DE: 'DE',
});

export type Licence = ObjectValuesUnionType<typeof Licences>;

export const AuthorizedLicences = [Licences.FR, Licences.ES, Licences.DE];

// Locales
export const Locales = Object.freeze({
  EN: 'en',
  DE: 'de',
  PT: 'pt',
  IT: 'it',
  ES: 'es',
  FR: 'fr',
});

export type Locale = ObjectValuesUnionType<typeof Locales>;

export const LocalesLong = Object.freeze({
  [Locales.EN]: 'en_US',
  [Locales.DE]: 'de_DE',
  [Locales.PT]: 'pt_PT',
  [Locales.IT]: 'it_IT',
  [Locales.ES]: 'es_ES',
  [Locales.FR]: 'fr_FR',
});

export type LocaleLong = ObjectValuesUnionType<typeof LocalesLong>;

// Locales basename
export const LocalesBasename = {
  [Locales.FR]: 'paris-sportifs',
  [Locales.EN]: 'en/sports-betting',
  [Locales.ES]: 'apuestas-deportivas',
  [Locales.DE]: 'sportwetten',
  [Locales.IT]: 'scommesse-sportive',
  [Locales.PT]: 'apostas-desportivas',
};

export const CardModes = Object.freeze({
  NORMAL: 'NORMAL',
  PROMO: 'PROMO',
  BOOSTED: 'BOOSTED',
  BIG_BOOSTED: 'BIG_BOOSTED',
  XMAS_BOOSTED: 'XMAS_BOOSTED',
  MISSIONS_BANNER: 'MISSION_BANNER',
});
export type CardMode = ObjectValuesUnionType<typeof CardModes>;

export const MenuKeyTypes = Object.freeze({
  DEFAULT: 'default',
});
export type MenuKeyType = ObjectValuesUnionType<typeof MenuKeyTypes>;
